import { Button, RadioButtonGroup } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { useNotification } from 'hooks'
import { useState } from 'react'
import { useMutation } from 'react-query'
import { makeCoreGetRequest } from 'utils/api'
import { handleQueryError } from 'utils/helpers'

const SelectStoreModal = ({ isModalOpen, closeModal, stores }) => {
  const [selectedStoreCode, setSelectedStoreCode] = useState<number>(null)

  const { showNotification } = useNotification()

  const submitSelectedStore = async () => {
    await makeCoreGetRequest(`/shop-reception-mobile/home/select-shop/${selectedStoreCode}`)
  }

  const { mutate: saveData } = useMutation(submitSelectedStore, {
    onSuccess: res => {
      localStorage.setItem('selectedStoreCode', `${selectedStoreCode}`)
      closeModal()
    },
    onError: error =>
      handleQueryError(error, 'A aparut o eroare la salvarea locatiei.', showNotification)
  })

  const changeSelectedStore = (e, option) => {
    setSelectedStoreCode(option)
  }

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={() => {
        if (localStorage.getItem('selectedStoreCode')) {
          closeModal()
        }
      }}
      modalTitle="Selecteaza magazin"
    >
      <Grid container spacing={4} style={{ marginBottom: '40px' }}>
        <Grid xs={12} item>
          <RadioButtonGroup
            label=""
            dotStyle
            name="store"
            onChange={changeSelectedStore}
            value={selectedStoreCode}
            options={stores}
          />
        </Grid>
      </Grid>
      <Grid xs={12} item className={s.modalButtons}>
        <Button variant="contained" label="Salveaza" onClick={() => saveData()} />
      </Grid>
    </Modal>
  )
}

export default SelectStoreModal
